export const pagesIdManagementsEn = {
  list: {
    pageTitle: "IDs",
    filterPlaceholder: "Search by ID, name, email, etc.",
    addId: "Add ID",
    tabs: {
      all: "All",
      personalId: "Personal ID",
      boardMemberId: "Board Member ID",
      employeeId: "Employee ID",
      contractorId: "Contractor ID",
      collaboratorId: "Collaborator ID",
      groupId: "Group ID",
      unknownId: "Unknown ID",
    },
    columns: {
      id: "ID",
      personName: "Name",
      appName: "App",
    },
    unknownIdsActionsColumn: {
      createGroupId: "Transform to  Group ID",
    },
  },
  groupId: {
    details: {
      tabs: {
        members: "Members",
        ruleAndPolicy: "Rules & Policy",
        settings: "Settings",
      },
      members: {
        filterPlaceholder: "Filter by name, email...",
      },
      settings: {
        basicSettings: {
          title: "Basic Settings",
          basicInformation: {
            title: "Basic Information",
            description: "Edit basic information",
            loginIdLabel: "Login ID",
            loginIdPlaceholder: "Enter Login ID",
            nameLabel: "Name",
            namePlaceholder: "Enter Name",
            updateSuccessTitle: "Success",
            updateSuccessMessage: "Group ID information updated successfully",
            updateErrorTitle: "Error",
            updateErrorMessage: "Failed to update Group ID information",
            editButtonLabel: "Edit",
            updateButtonLabel: "Update",
          },
        },
        dangerZone: {
          title: "Danger Zone",
          deleteGroupId: {
            title: "Delete Group ID",
            description:
              "This action cannot be undone. Note that the ID may remain as a non-group ID.",
            buttonLabel: "Delete Group ID",
          },
          deleteDialog: {
            title: "Are you sure you want to delete Group ID?",
            description: "This action cannot be undone.",
            deleteSuccessTitle: "Successfully Deleted Group ID",
            deleteErrorTitle: "Error deleting Group ID",
            cancelButtonLabel: "Cancel",
            deleteButtonLabel: "Delete",
          },
        },
      },
    },
    add: {
      title: "Add Group ID",
      step1: {
        title: "Basic Information",
        loginIdLabel: "Login ID",
        loginIdPlaceholder: "Enter Login ID",
        nameLabel: "Name",
        namePlaceholder: "Enter Name",
        submitButtonLabel: "Submit",
      },
      completeDialog: {
        message: "ID has been added successfully.",
        completeLinkButton: "Go to ID Details",
      },
    },
    detail: {
      changePeopleGroup: "Change People Group",
      edit: "Edit Conditions",
      selectPeopleGroup: "Select People Group",
      createPeopleGroupIfNotExists:
        "If there is no necessary People Group, create one.",
      toPeopleGroup: "Open People Group",
      needToSelectPeopleGroup:
        "Select a People Group to assign members to the Group ID",
    },
  },
};
